import axios from 'axios';

const resolveToken = (token) => token || sessionStorage.getItem('token');

const buildAuthConfig = (token, contentType) => {
  const resolvedToken = resolveToken(token);
  const headers = {
    Authorization: `Bearer ${resolvedToken}`,
  };

  if (contentType) {
    headers['Content-Type'] = contentType;
  }

  return { headers };
};

export const getManagers = async (token) => {
  const res = await axios.get('/api/managers', buildAuthConfig(token));
  return res.data;
};

export const getActiveManagers = async (token) => {
  const res = await axios.get('/api/managers/active', buildAuthConfig(token));
  return res.data;
};

export const getManager = async (id, token) => {
  const res = await axios.get(`/api/managers/${id}`, buildAuthConfig(token));
  return res.data;
};

export const getManagerByDomain = async (domain, token) => {
  const res = await axios.get(`/api/managers/domain/${encodeURIComponent(domain)}`, buildAuthConfig(token));
  return res.data;
};

export const createManager = async (data, token) => {
  const isFormData = data instanceof FormData;
  const res = await axios.post('/api/managers', data,
    buildAuthConfig(token, isFormData ? 'multipart/form-data' : 'application/json')
  );
  return res.data;
};

export const updateManager = async (id, data, token) => {
  const isFormData = data instanceof FormData;
  const res = await axios.put(`/api/managers/${id}`, data,
    buildAuthConfig(token, isFormData ? 'multipart/form-data' : 'application/json')
  );
  return res.data;
};

export const deleteManager = async (id, token) => {
  const res = await axios.delete(`/api/managers/${id}`, buildAuthConfig(token));
  return res.data;
};

// Left Menu (tdx_menu)
export const getLeftMenus = async (token) => {
  const res = await axios.get('/api/left-menus', buildAuthConfig(token));
  return res.data;
};

export const getLeftMenu = async (id, token) => {
  const res = await axios.get(`/api/left-menus/${id}`, buildAuthConfig(token));
  return res.data;
};

export const createLeftMenu = async (data, token) => {
  const res = await axios.post('/api/left-menus', data, buildAuthConfig(token, 'application/json'));
  return res.data;
};

export const updateLeftMenu = async (id, data, token) => {
  const res = await axios.put(`/api/left-menus/${id}`, data, buildAuthConfig(token, 'application/json'));
  return res.data;
};

export const deleteLeftMenu = async (id, token) => {
  const res = await axios.delete(`/api/left-menus/${id}`, buildAuthConfig(token));
  return res.data;
};

// Left Menu Item (tdx_menu_item)
export const getLeftMenuItems = async (token) => {
  const res = await axios.get('/api/left-menus/items', buildAuthConfig(token));
  return res.data;
};

export const getLeftMenuItemsByMenu = async (menuId, token) => {
  const res = await axios.get(`/api/left-menus/items/menu/${menuId}`, buildAuthConfig(token));
  return res.data;
};

export const getLeftMenuItem = async (id, token) => {
  const res = await axios.get(`/api/left-menus/items/${id}`, buildAuthConfig(token));
  return res.data;
};

export const createLeftMenuItem = async (data, token) => {
  const res = await axios.post('/api/left-menus/items', data, buildAuthConfig(token, 'application/json'));
  return res.data;
};

export const updateLeftMenuItem = async (id, data, token) => {
  const res = await axios.put(`/api/left-menus/items/${id}`, data, buildAuthConfig(token, 'application/json'));
  return res.data;
};

export const deleteLeftMenuItem = async (id, token) => {
  const res = await axios.delete(`/api/left-menus/items/${id}`, buildAuthConfig(token));
  return res.data;
};

// Portlet Item (tdx_portlet_item)
export const getPortlets = async (token) => {
  const res = await axios.get('/api/portlets', buildAuthConfig(token));
  return res.data;
};

export const getPortlet = async (id, token) => {
  const res = await axios.get(`/api/portlets/${id}`, buildAuthConfig(token));
  return res.data;
};

export const createPortlet = async (data, token) => {
  const res = await axios.post('/api/portlets', data, buildAuthConfig(token, 'application/json'));
  return res.data;
};

export const updatePortlet = async (id, data, token) => {
  const res = await axios.put(`/api/portlets/${id}`, data, buildAuthConfig(token, 'application/json'));
  return res.data;
};

export const deletePortlet = async (id, token) => {
  const res = await axios.delete(`/api/portlets/${id}`, buildAuthConfig(token));
  return res.data;
};
